import { MailingId } from 'modules/mailing/types/mailing-interface'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'

interface AttachmentsPolicyInterface {
  willBeSentAsLinks: boolean
}

export const useAttachmentsPolicy = (mailingId?: MailingId) => {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, AttachmentsPolicyInterface>({
    method: RequestMethodsEnum.get,
  })

  return useControlledSwr(
    `/api/dashboard/customer/mailing/${mailingId}/attachment-policy`,
    fetcher,
    {},
    !!user && !!mailingId,
  )
}
